import { Section } from '@web_opxp/components';
import { useTranslation } from '@web_opxp/features';
import { IDomainCalculation } from '../../base/types';
import CFQResultCard from './CFQResultCard';

export interface ICFQEvaluationProps {
  domains: IDomainCalculation[];
}

export default function CFQEvaluation({ domains }: Readonly<ICFQEvaluationProps>) {
  const { t } = useTranslation();

  return (
    <Section className="self-evaluation-view">
      <div className="row">
        <div className="col">
          <h2>{t('CFQ.Evaluation.Title')}</h2>
        </div>
      </div>
      <div className="row">
        {domains.map(({ domainId, value }) => (
          <div key={domainId} className="col-4">
            <CFQResultCard domainId={domainId} value={value} />
          </div>
        ))}
      </div>
      <div className="row description">
        <div className="col-7">
          <p>{t('CFQ.Evaluation.Description')}</p>
        </div>
      </div>
    </Section>
  );
}
